import React from 'react';
import { useDropTarget } from '../../hooks/useDragAndDrop';
import './DnD.scss';

/**
 * Reusable drop target component
 * @param {string|array} acceptTypes - The type(s) of items this target accepts
 * @param {function} onDrop - Callback when an item is dropped
 * @param {function} onHover - Optional callback when hovering
 * @param {ReactNode} children - The content to render
 * @param {string} className - Additional CSS classes
 * @param {boolean} showDropIndicator - Whether to show visual drop indicator
 * @param {string} targetItemId - The ID of the target item (returned in drop result)
 */
const DropTarget = ({
    acceptTypes,
    onDrop,
    onHover = null,
    children,
    className = '',
    showDropIndicator = true,
    targetItemId = null
}) => {
    const { isOver, canDrop, drop } = useDropTarget(acceptTypes, onDrop, onHover, targetItemId);

    const dropClassName = `
        drop-target 
        ${className} 
        ${isOver && canDrop ? 'drag-over' : ''} 
        ${canDrop ? 'can-drop' : ''}
    `.trim();

    return (
        <div ref={drop} className={dropClassName}>
            {showDropIndicator && isOver && canDrop && (
                <div className="drop-indicator">
                    <span>Drop here</span>
                </div>
            )}
            {children}
        </div>
    );
};

export default DropTarget;
